import React, { createContext, useContext, useEffect, useState } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "./firebaseConfig";

export interface PartnerType {
    id: string;
    docId: string;
    name: string;
    timestamp?: number;
}

interface PartnerContextType {
    partner: PartnerType[];
}

const PartnerContext = createContext<PartnerContextType | null>(null);

export const PartnerProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [partner, setPartners] = useState<PartnerType[]>([]);

    useEffect(() => {
        const unsubscribe = onSnapshot(query(collection(db, "partner")), (snapshot) => {
            const lists = snapshot.docs
                .map((doc) => doc.data() as PartnerType)
                .sort((a, b) => {
                    if (a.timestamp && b.timestamp) return a.timestamp - b.timestamp;
                    else return 0;
                });
            setPartners(lists);
        });
        return () => unsubscribe();
    }, []);

    return (
        <PartnerContext.Provider
            value={{
                partner,
            }}
        >
            {children}
        </PartnerContext.Provider>
    );
};

export const usePartner = (): PartnerContextType => {
    const context = useContext(PartnerContext);
    if (!context) {
        throw new Error("usePartner must be used within an PartnerProvider");
    }
    return context;
};
